import { HomeSectionLayout } from '../../../components/HomeSectionLayout';
import NavigationsDisplay from '../../Reference/ReferencesSectionsList';

export default function ReferencesSection({
  referencesSections
}: any) {
  return (
    <HomeSectionLayout.Container>
      <HomeSectionLayout.Header>Reference</HomeSectionLayout.Header>
      <HomeSectionLayout.Content>
        <NavigationsDisplay
          referencesSections={referencesSections}
        />
      </HomeSectionLayout.Content>
    </HomeSectionLayout.Container>
  )
}
